module.exports = __webpack_public_path__ + "img/channels.50b7d8c4.svg";